import BaseClass from "../BaseClass.js";

export default class UserCamHandler extends BaseClass {

    constructor(element) {
        super(element);

        this.subscriber = null;
        this.$startStopButton = null;
        this.$userStreamTimer = null;
        this.streamTimerInterval = null;
        this.streamStartTS = null;
        this.host = null;
        this.roomName = null;
        this.username = null;
        this.password = null;
        this.token = null;
        this.chatServerURL = null;
        this.sdkURL = null;
        this.subscriberEventsHandler = null;

        this.init();
    }

    init() {
        let mySelf = this;

        if (this.$element.attr("data-host") != undefined) {
            this.host = this.$element.attr("data-host");
        }

        if (this.$element.attr("data-room") != undefined) {
            this.roomName = this.$element.attr("data-room");
        }

        if (this.$element.attr("data-username") != undefined) {
            this.username = this.$element.attr("data-username");
        }
        if (this.$element.attr("data-password") != undefined) {
            this.password = this.$element.attr("data-password");
        }
        if (this.$element.attr("data-token") != undefined) {
            this.token = this.$element.attr("data-token");
        }

        if (this.$element.attr("data-chat-host") != undefined) {
            this.chatServerURL = this.$element.attr("data-chat-host");
        }

        if (this.$element.attr("data-sdk-url") != undefined) {
            this.sdkURL = this.$element.attr("data-sdk-url");
            this.loadRed5SDK();
        } else {
            console.error("no sdk url");
        }

        let userStreamTimer = this.$element.find('[data-type="user-stream-timer"]').first();

        if (userStreamTimer != undefined) {
            this.$userStreamTimer = userStreamTimer;
        }

        //  this.startUserChat(); // TODO Nur lokal aktivieren
    }

    loadRed5SDK() {
        let mySelf = this;
        var red5ProSdkScript = document.createElement("script");
        red5ProSdkScript.src = this.sdkURL

        document.body.appendChild(red5ProSdkScript);

        $(red5ProSdkScript).on('load', function () {
            red5prosdk.setLogLevel('debug');
            console.error("red5pro sdk loaded");
            mySelf.prepareSubscribing();
        });
    }

    prepareSubscribing() {
        this.createMainConfig();
        this.createListener();
        this.startSubscribe();
    }


    createListener() {

        let mySelf = this;

        this.subscriberEventsHandler = function (event, data) {

            console.error(event.type);
            console.error(event);

            if (event.type === 'Connect.Success') {
                console.error("Connect.Success");
            }
            if (event.type === 'Subscribe.Start') {
                mySelf.startUserChat();
                console.error("cam:subscribe:started");
            } else if (event.type === 'Subscribe.Stop') {
                mySelf.stopUserChat();
                console.error("cam:subscribe:stopped");
                $(document).trigger('modals:hide');
            } else if (event.type === 'Subscribe.Connection.Closed') {
                mySelf.stopUserChat();
                console.error("cam:subscribe:stopped");
                $(document).trigger('modals:hide');
            } else if (event.type === 'Subscribe.Metadata') {
                if (event.data.streamingMode && event.data.streamingMode === 'Audio') {
                    // if audio only broadcast `canplay` may come in on the element before `Subscribe.Start`.
                }
            } else if (event.type === 'Subscribe.Time.Update') {
                mySelf.handleStreamTimeUpdate(event.data);
            }
        }

        this.chatEventListener = function (event, data) {
            console.error(event);
            console.error(data);
            if (data.action != undefined) {
                switch (data.action) {
                    case "stopStream":
                        $(document).trigger('modals:hide');
                        console.error("stopStream");
                        break;
                }

            }
        }

        $(document).on('stream:event', this.chatEventListener);
    }

    startSubscribe() {

        let mySelf = this;

        var subscriber = new red5prosdk.WHEPClient();

        subscriber.init(this.baseConfiguration)
            .then(function (subscriber) {
                mySelf.subscriber = subscriber;
                mySelf.subscriber.on('*', mySelf.subscriberEventsHandler);
                console.error(subscriber);
                return subscriber.subscribe();
            })
            .then(function (subscriber) {


            })
            .catch(function (error) {
                console.error(error)
            });
    }


    createMainConfig() {

        this.iceServers = [
            {
                urls: [
                    'stun:stun.l.google.com:19302',
                    'stun:stun1.l.google.com:19302',
                    'stun:stun2.l.google.com:19302',
                    'stun:stun3.l.google.com:19302',
                    'stun:stun4.l.google.com:19302',
                ],
            },
        ];

        this.baseConfiguration = {
            host: this.host,
            protocol: 'wss',
            port: '443',
            app: 'live',
            rtcConfiguration: {
                iceServers: this.iceServers,
                iceCandidatePoolSize: 2,
                bundlePolicy: 'max-bundle',
            },

            signalingSocketOnly: true,
            enableChannelSignaling: true,
            mediaElementId: 'red5pro-subscriber',

            connectionParams: {username: this.username, password: this.password, token: this.token},
            path: 'keintest',
            streamName: this.roomName,
        }
    }

    startUserChat() {
        console.error("startUserChat");
        $(document).trigger('user:camchat:start', {authToken: this.token, roomName: this.roomName, serverURL: this.chatServerURL});
    }

    stopUserChat() {
        $(document).trigger('user:camchat:stop', {roomName: this.roomName});
    }

    handleStreamTimeUpdate(eventData) {
        const mySelf = this;

        if (mySelf.$userStreamTimer != null) {
            const timeInSeconds = Math.floor(eventData.time);

            const hours = Math.floor(timeInSeconds / 3600);
            const minutes = Math.floor((timeInSeconds % 3600) / 60);
            const seconds = timeInSeconds % 60;

            mySelf.$userStreamTimer.text(`${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`);
        }
    }


    /**
     * @deprecated
     */
    startStreamTimer() {
        let mySelf = this;

        if (mySelf.$userStreamTimer != null) {
            mySelf.streamStartTS = Math.floor(Date.now() / 1000);

            if (mySelf.streamTimerInterval) {
                clearInterval(mySelf.streamTimerInterval);
            }

            mySelf.$userStreamTimer.removeClass('hidden');

            mySelf.streamTimerInterval = setInterval(() => {
                const now = Math.floor(Date.now() / 1000);
                const elapsed = now - mySelf.streamStartTS;

                const hours = Math.floor(elapsed / 3600);
                const minutes = Math.floor((elapsed % 3600) / 60);
                const seconds = elapsed % 60;

                mySelf.$userStreamTimer.text(`${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`);

                if (mySelf.streamEnded) {
                    clearInterval(mySelf.streamTimerInterval);
                }
            }, 1000);
        }
    }

    /**
     * @deprecated
     */
    stopStreamTimer() {
        if (this.streamTimerInterval) {
            clearInterval(this.streamTimerInterval);
            this.streamTimerInterval = null;
        }
    }

    destroyListener() {
        console.error("destroyListener");
        this.subscriber.unsubscribe();
        this.subscriber.off('*', this.subscriberEventsHandler);
        this.subscriber = null;
    }

}